module.exports = __webpack_public_path__ + "static/media/boy-22.9ce3ae89.svg";